<template>
  <div id="hfq-content" class="we-technology hfq-content">
    <Header></Header>
    <div class="section section-1">
      <div class="scale-img">
        <img src="@/assets/images/weicai/weTech/main.jpg" alt="" />
      </div>
    </div>
    <div class="section-2">
      <div class="content">
        <div class="card" v-for="(item, index) in cards" :key="item.title">
          <img
            class="big-icon"
            :class="index % 2 === 0 ? 'left' : 'right'"
            :src="item.icon"
            alt=""
          />
          <img :src="item.titleIcon" class="title-icon" :class="'title-icon-' + index" alt="" />
          <div class="desc " :class="'desc-' + index">{{ item.desc }}</div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from '@/components/header'
import Footer from '@/components/footer'
import { keywordsList, descriptionList } from '../../config'

export default {
  components: {
    Header,
    Footer
  },
  data () {
    return {
      cards: [
        {
          icon: require('@/assets/images/weicai/weTech/card1.png'),
          title: '/智慧营销方案',
          titleIcon: require('@/assets/images/weicai/weTech/card-title1.png'),
          desc:
            '基于独有的数据特征和算法，自研用户分层模型，通过技术打造多层次自动化营销策略，为用户带去丰富体验。'
        },
        {
          icon: require('@/assets/images/weicai/weTech/card2.png'),
          title: '/智能信审引擎',
          titleIcon: require('@/assets/images/weicai/weTech/card-title2.png'),
          desc:
            '采用机器学习前沿算法，全作业流程100%自动化，助力金融机构快速授信；并通过多维模型，打造可靠反诈屏障。'
        },
        {
          icon: require('@/assets/images/weicai/weTech/card3.png'),
          title: '/资金管理系统',
          titleIcon: require('@/assets/images/weicai/weTech/card-title3.png'),
          desc:
            '通过项目配置、额度管控、数据驾驶舱满足金融机构项目的个性化需求和精细化运营，目前已服务数十家银行、消金公司、信托等金融机构，承载着千万级的订单数量。'
        },
        {
          icon: require('@/assets/images/weicai/weTech/card4.png'),
          title: '/资产管理平台',
          titleIcon: require('@/assets/images/weicai/weTech/card-title4.png'),
          desc:
            '运用大数据及AI算法，建立一站式、多层次的科学管理体系，在智能客服、多元调解、系统能力输出等方面赋能行业。'
        }
      ],
      abilitys: [
        {
          icon: require('@/assets/images/weicai/weTech/ability-img1.png'),
          desc: '智慧营销方案'
        },
        {
          icon: require('@/assets/images/weicai/weTech/ability-img2.png'),
          desc: '资产管理平台'
        },
        {
          icon: require('@/assets/images/weicai/weTech/ability-img3.png'),
          desc: '智能信审系统'
        },
        {
          icon: require('@/assets/images/weicai/weTech/ability-img4.png'),
          desc: '资金管理系统'
        }
      ]
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    // document.title = titles.weTechnology;
    // if(!common.isMetaName('keywords')){
    //   this.createMeta()
    // }
  },
  methods: {
    createMeta () {
      let head = document.getElementsByTagName('head')
      let keywordsMeta = document.createElement('meta')
      let descriptionMeta = document.createElement('meta')
      keywordsMeta.name = 'keywords'
      keywordsMeta.content = keywordsList[1]
      descriptionMeta.name = 'description'
      descriptionMeta.content = descriptionList[1]
      head[0].appendChild(keywordsMeta)
      head[0].appendChild(descriptionMeta)
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/style/weicai.less";
@import "./index.less";
</style>



// WEBPACK FOOTER //
// src/pages/weTech/index.vue